<template>
    <div v-loading="loading">
        <div class="header-btn">
            <el-button type="warning" size="small" icon="el-icon-plus" @click="add"></el-button>
        </div>

        <el-form inline ref="form" :model="queryForm" style="text-align: center">
            <el-form-item>
                <el-input clearable v-model="queryForm.phone" placeholder="Phone"></el-input>
            </el-form-item>

            <el-form-item v-if="isEazable">
                <el-select clearable v-model="queryForm.cid" placeholder="Company">
                    <el-option
                            v-for="item in company"
                            :key="'s-s-a-'+item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-button type="primary" icon="el-icon-search" circle @click="loadData"></el-button>
        </el-form>

        <el-table fit stripe highlight-current-row :data="data">
            <el-table-column v-for="item in [
                              {prop:'uid',label:'UID'},
                              {prop:'userName',label:'Name'},
                              {prop:'phone',label:'Login ID'},
                              ]"
                             :prop="item.prop"
                             :label="item.label"
                             :key="item.label">
            </el-table-column>

            <el-table-column label="Allow Editing">
                <template slot-scope="s">
                    <el-tag type="success" v-model="s.row.role">
                        <template v-if="s.row.writable">Yes</template>
                        <template v-else>No</template>
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="User Role">
                <template slot-scope="s">
                    <el-tag type="success" v-model="s.row.role">
                        {{s.row.role | userRole}}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column
                    label="Status">
                <template slot-scope="s">
                    {{s.row.status | stat}}
                </template>
            </el-table-column>

            <el-table-column label="Action" width="120px" align="center">
                <template slot-scope="s">
                    <el-button type="primary" circle @click="openEdit(s.row)" icon="el-icon-edit"></el-button>

                    <el-tooltip :content="s.row.status===2?'Activate':'Deactivate'" placement="top">
                        <el-button type="text" circle @click="changeStatus(s.row)"
                                   :style="s.row.status===2?'background-color: #19be6b;color: white':'background-color: #FF3030;color: white'"
                                   :icon="s.row.status===2?'el-icon-turn-off':'el-icon-open'"></el-button>
                    </el-tooltip>

                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination v-if="page.total>1"
                           @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>

            <el-dialog
                    center
                    :close-on-click-modal="false"
                    :visible.sync="dialogVisible"
                    width="700px">
                <el-form ref="form" :model="form" label-position="left" label-width="120px" :rules="rules">
                    <el-form-item label="Login ID" prop="phone">
                        <el-input v-model="form.phone"
                                  placeholder="There only support Singapore mobile phone number"></el-input>
                    </el-form-item>

                    <el-form-item label="Password" prop="password">
                        <el-input v-model="form.password" placeholder="Enter password"></el-input>
                    </el-form-item>

                    <el-form-item label="User Name" prop="userName">
                        <el-input v-model="form.userName" placeholder="Enter user name"></el-input>
                    </el-form-item>

                    <el-form-item label="Role" prop="role">
                        <el-select v-model="form.role" @change="loadCompany" placeholder="Select a role">
                            <el-option
                                    v-for="item in roles"
                                    :disabled="item.disable"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Allow Editing" prop="writable" v-if=" form.role &&form.role===3">
                        <el-switch v-model="form.writable" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </el-form-item>

                    <el-form-item label="Super Admin" prop="writable" v-if=" form.role &&form.role===3 && isEazable ">
                        <el-switch v-model="form.isSuper" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </el-form-item>

                    <el-form-item label="Company" prop="cid">
                        <el-select v-model="form.cid" placeholder="Select company">
                            <el-option
                                    v-for="item in company"
                                    :key="'s-c-'+item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Property" prop="property">
                        <el-select v-model="form.property" multiple placeholder="Select property">
                            <el-option
                                    v-for="item in property"
                                    :key="'s-p-'+item.propertyId"
                                    :label="item.propertyName"
                                    :value="item.propertyId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <span slot="footer">
                    <el-button type="primary" @click="saveData">Save</el-button>
                    <el-button @click="dialogVisible = false">Cancel</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {listAccounts, changeStatus, createNewAccountInfo, updateAccount} from '@/api/MaAccountManageApi'
    import {allProperty} from '@/api/AuthApi'
    import {listCompanyByType} from '@/api/CompanyAPI'
    import {mapGetters} from "vuex";


    export default {
        name: 'MaAccountManage',
        data() {
            const valPassword = (rule, value, callback) => {
                if (this.isCreate) {
                    if (!value) {
                        callback(new Error('Password is required'))
                        return
                    }
                }
                callback();
            };
            return {
                queryForm: {},
                form: {password: ''},
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                loading: false,
                data: [],
                rules: {
                    phone: [
                        {required: true, message: 'The login id is required', trigger: 'blur'},
                    ],
                    role: [
                        {required: true, message: 'Please check a role for this account', trigger: 'blur'},
                    ],
                    cid: [
                        {required: true, message: 'Please check a company for this account', trigger: 'blur'},
                    ],
                    password: [
                        {validator: valPassword, trigger: 'blur'}
                    ]
                },
                roles: [],
                property: [],
                company: [],
                dialogVisible: false,
                allPropertyName: {},
                isCreate: false
            }
        },
        computed: mapGetters({
            isEazable: 'isEazable'
        }),
        methods: {
            loadData() {
                this.$pageUtils(this, listAccounts)
                this.loadCompany()
            },
            add() {
                this.dialogVisible = true
                this.form = {}
                this.isCreate = true
                allProperty().then(res => this.property = res.data)
            },
            openEdit(data) {
                this.isCreate = false
                this.form = JSON.parse(JSON.stringify(data))
                this.loadCompany()
                allProperty().then(res => this.property = res.data)
                this.dialogVisible = true

            },
            loadCompany() {
                let param = 'MANAGE'
                if (this.form.role === 4) {
                    param = 'VENDOR'
                }
                listCompanyByType(param)
                    .then(item => this.company = item.data);
            },
            changeStatus(data) {
                changeStatus(data.uid)
                    .then(this.loadData);
            },
            saveData() {
                const action = this.form.uid ? updateAccount : createNewAccountInfo
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const form = this.$copy(this.form)
                        if (form.password) {
                            if (!this.isCreate) {
                                if (!confirm("Confirm change user`s password?")) {
                                    return
                                }
                            }
                            form.password = this.$md5(form.password);
                        }
                        action(form)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible = false
                            }).catch(er => {
                            this.$msgbox.alert(er.data)
                        });
                    }
                })

            }
        },
        filters: {
            stat(st) {
                const status = {
                    2: 'InActive',
                    1: 'Active',
                    3: 'New'
                }
                return status[st]
            },
            userRole(oc) {
                const userRole = {
                    0: 'Tenant',
                    1: 'Account/User',
                    3: 'MA',
                    4: 'Vendor'
                }
                return userRole[oc]
            }
        },
        mounted() {
            this.loadData()
            this.roles.push({value: 3, label: 'MA', disable: false})
            this.roles.push({value: 4, label: 'Vendor', disable: this.isEazable})
        }
    }
</script>

<style scoped>
    .el-button{
        margin: 0 5px 0 0;
    }
</style>
